import { getApiV2VouchersCode } from '@/api/pensa';
import { queries } from '@/api/queries';
import { useQuery } from '@tanstack/vue-query';

const useGetVoucherInfo = (code: Ref<string | null | undefined>) => {
  const enabled = computed(() => !!code.value);
  return useQuery({
    ...queries.vouchers.byId(code),
    queryFn: async () => {
      const result = await getApiV2VouchersCode(code.value!);
      return result.data;
    },
    enabled,
  });
};

export default useGetVoucherInfo;
